const React = require('react');
const ControlledDateField = require('./ControlledDateField');
const FieldContext = require('./FieldContext');

module.exports = function FormDateField(props) {

    const {
        field = {},
        fieldName = field.name,
        label = field.label,
        onBlur,
        onChange,
        onFocus,
        setValue,
        textFieldProps = {},
        useField: requestedUseFieldHook,
        value
    } = props;

    const resolvedUseField = typeof requestedUseFieldHook === 'function'
        ? requestedUseFieldHook
        : FieldContext.useField;

    const fieldController = resolvedUseField(fieldName);
    const resolvedValue = typeof value === 'undefined'
        ? fieldController.getValue()
        : value;
    const setFieldValue = typeof setValue === 'function'
        ? setValue
        : fieldController.setValue;

    return <ControlledDateField
        label={label}
        value={resolvedValue}
        onBlur={(event) => {
            fieldController.onBlur?.(event);
            onBlur?.(event);
        }}
        onChange={(nextValue, event) => {

            setFieldValue(nextValue, event);

            if (typeof onChange === 'function') {
                onChange(nextValue, event);
            }
        }}
        onFocus={(event) => {
            fieldController.onFocus?.(event);
            onFocus?.(event);
        }}
        textFieldProps={textFieldProps}
    />;
};
